import { FocusEditor } from "./focus-editor";

export const TheEditor = () => {
  return <FocusEditor />;
};
